import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useRouteMatch } from "react-router";
import BaseLayout from "../../../components/layouts/BaseLayout";
import useSafeSetState from "../../../hooks/useSafeSetState";
import {
  editIncident,
  getIncident,
} from "../../../apiCalls/admin/vehicleIncidents";
import { setAlert } from "../../../redux/actions/actions";
import VehicleIncident from "./VehicleIncident";
import { RootStateInterface } from "../../../interfaces/ReduxInterface";

const VehicleIncidentView = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentCustomer = useSelector(
    (state: RootStateInterface) => state.customer.currentCustomer,
  );
  const match = useRouteMatch({
    path: "/admin/fleet/incidents/:incidentId",
    strict: true,
    sensitive: true,
  });
  const { incidentId } = match?.params as any;

  const [{ incident }, setState] = useSafeSetState({
    incident: {},
  });

  useEffect(() => {
    const customerId = currentCustomer?.shortname;
    getIncident(customerId, incidentId).then((data) => {
      setState({
        incident: data?.data || {},
      });
    });
  }, []);

  const handleCancel = () => {
    history.push("/admin/fleet/incidents");
  };

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const handleSave = (incident) => {
    const data = {
      vehicle_id: incident.vehicle_id,
      damages: incident.damages || [],
    };
    editIncident(currentCustomer?.shortname, incidentId, data)
      .then(handleCancel)
      .catch(() => dispatch(setAlert("An error occurred", "error")));
  };

  return (
    <BaseLayout
      title={`Edit Incident ${incidentId}`}
      handleArrowClick={handleCancel}
    >
      <VehicleIncident
        initialIncident={incident}
        handleCancel={handleCancel}
        handleSave={handleSave}
      />
    </BaseLayout>
  );
};

export default VehicleIncidentView;
